export const en = {
  eventManagementPage: {
    meta: { title: 'Event Management' },
    hero: {
      eyebrow: 'Event Management',
      heading_main: 'Shifts, waitlists, and real-time availability',
      heading_em: '',
      lead: 'Purposely runs the logistics of every volunteer event for you. Employees notified of open shifts, open shifts fill themselves, waitlists promote the moment a spot frees up, and live availability shows you exactly where the gaps are before they become a problem.',
    },
    availStrip: 'Live across every Purposely event — updated the moment an RSVP changes.',
    shifts: {
      name: 'Smart Shifts',
      status: 'Live',
      headline: 'Open a shift. Employees notified instantly',
      desc: 'Define when, where, and how many hands you need — Purposely takes it from there. Our matching engine surfaces each shift to the employees most likely to show up, and quietly nudges fence-sitters when seats are still open.',
      features: [
        'One-click sign-up for any shift',
        'Hours and impact post back to your reporting dashboard the moment a shift ends',
      ],
      cta: 'See shifts in action →',
    },
    waitlists: {
      name: 'Auto-Promoting Waitlists',
      status: 'Live',
      headline: "Someone can't make it? The next person's already in",
      desc: "Every popular shift has a waitlist behind it. The moment an RSVP cancels, the next match in line is promoted, notified, and added to the roster — no chasing, no awkward \"we found a spot\" emails the night before.",
      features: [
        'Auto-promotes on cancellation with a 30-min confirmation window',
        "Smart fallback: skips the queue if a teammate already RSVP'd",
        'Full audit trail of who was offered the spot and when',
      ],
      cta: 'See waitlists at work →',
    },
    privateShifts: {
      name: 'Private & invite-only shifts',
      status: 'Live',
      headline: 'Your guest list for your event',
      desc: 'Not every opportunity belongs on the company-wide calendar. Team leads can restrict any shift to a specific group — useful for leadership days, pilot programs, or partnerships you want to keep contained.',
      features: [
        'Scope a shift to specific teams or a hand-picked invite list',
        'Invite-only: only the people you add can see or RSVP to the shift',
        'Full audit trail of who was offered the spot and when',
      ],
      cta: 'See private shifts →',
    },
    availability: {
      name: 'Real-time availability',
      status: 'Live',
      headline: 'See where the gaps are — before they become problems',
      desc: "A live heatmap of when your people are most likely to volunteer, broken down by team, time, and cause. Plan around it: post shifts at peak windows, route nudges where engagement is dipping, and never schedule into a graveyard slot again.",
      features: [
        'Heatmap of historical & predicted availability across the org',
        "Live RSVP velocity — see a shift's fill rate the moment it's posted",
        'Slack and Teams presence-aware nudges (no DMs at 9pm)',
        'Auto-suggest the best date and time when you create a new event',
      ],
      cta: "See your team's heatmap →",
    },
    faq: {
      heading: 'Logistics, Capacity & Control',
      items: [
        {
          q: 'Can I see who\'s attended and who didn\'t show?',
          a: 'Yes. Every shift closes with an automatic attendance log -- who confirmed, who showed up, and who was a no-show. It all feeds into your post-event feedback so you\'re never chasing coordinators for headcount after the fact.',
        },
        {
          q: 'What happens when someone cancels at the last minute?',
          a: "We notify the next person on the list, though it's ultimately up to them whether they can make it. In practice, last-minute cancellations are rare. Employees get all the shift details upfront, so by the time they sign up they're genuinely committed.",
        },
      ],
    },
    cta: {
      heading_main: 'Stop chasing RSVPs.',
      heading_em: 'Start running events',
      sub: "Book a quick demo and we'll walk you through it.",
      button: 'Book a demo →',
    },
  },
}
